import { render, staticRenderFns } from "./Processando.vue?vue&type=template&id=a5ffca40"
import script from "./Processando.vue?vue&type=script&lang=js"
export * from "./Processando.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports